module.exports = __webpack_public_path__ + "static/media/eggplant.73060838.png";